<template>
  <div class="home-wrap">
    <div class="padding-12-15 padding-b-30">
      <div class="title-text">修改密码</div>
      <div class="padding-15">
        <div><span class="color-666">手机号</span><span class="mobile">{{mobile}}</span></div>
        <div class="code-wrap">
          <div class="text-wrap">
            <input type="text" v-model="code" placeholder="请输入验证码">
          </div>
          <div v-show="!showCountDown" class="code-btn" @click="sendSms">
            获取验证码
          </div>
          <div v-show="showCountDown" class="clock-btn">
            重新发送({{countDown}})s
          </div>
        </div>
        <div class="input-wrap">
          <input type="password" placeholder="设置新密码" v-model="password">
          <img v-show="password" src="../../../../assets/img/login_btn_cancel.png" alt="">
        </div>
        <div class="input-wrap">
          <input type="password" placeholder="请再次输入新密码" v-model="repassword">
          <img v-show="repassword" src="../../../../assets/img/login_btn_cancel.png" alt="">
        </div>
        <div class="service-wrap">
          <span class="color-666 margin-r-30">是否开启客服</span>
          <van-radio-group v-model="isService">
            <van-radio name="1">
              开启
              <template #icon="props">
                <img class="img-icon" :src="isService == 1 ? activeIcon : inactiveIcon" />
              </template>
            </van-radio>
            <van-radio name="0">
              不开启
              <template #icon="props">
                <img class="img-icon" :src="isService == 0 ? activeIcon : inactiveIcon" />
              </template>
            </van-radio>
          </van-radio-group>
        </div>
        <div class="service-tip">客服开启之后，您的影票推广页会显示官方客服。您的粉丝购票过程有疑问，可以联系官方客服</div>
        <div class="padding-t-40">
          <span class="submit-btn" v-on:click="handleSubmit()">确定修改</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { forgetPwdSms, forgetPwd, getUserInfo, setting } from '@/api/user'
  import selectIcon from '@/assets/img/h5/btn_selected_s.png'
  import unSelectIcon from '@/assets/img/h5/btn_selected_n.png'
  export default {
    name: 'PromotionSetting',
    components:{
      selectIcon,
      unSelectIcon
    },
    data () {
      return {
        mobile: '',
        password: '',  //密码
        repassword: '', //确认密码
        code: '',  //验证码
        isService: '1',
        isForgetPassword:0,
        showCountDown:false,//显示倒计时
        countDown: 60,  //倒计时
        loading:false,
        activeIcon: selectIcon,
        inactiveIcon: unSelectIcon
      }
    },
    created(){
      this.getUserInfo();
    },
    methods: {
      getUserInfo(){
        getUserInfo().then((response) => {
          this.mobile = response.data.mobile
          this.isService = response.data.is_open_server
        }).catch(error => {
          console.log(error)
        })
      },
      sendSms(){
        if(!this.validatePhone()){
          this.$toast.fail(this.tip)
          return
        }
        if(this.showCountDown){
          return
        }
        this.showCountDown = true
        forgetPwdSms({
          nickname: this.nickname,
          mobile: this.mobile,
          isForgetPassword: this.isForgetPassword
        }).then(response => {
          this.$toast.success(response.message)
          this.timer = setInterval(()=>{
            this.countDown--
            if(this.countDown === 0){
              this.showCountDown = false
              this.countDown = 60;
              clearInterval(this.timer)
            }
          },1000)
        }).catch(error => {
          console.log(error)
          this.showCountDown = false
        })
      },
      handleSubmit: function () {
        if(this.loading){
          return
        }
        if(this.mobile !== '' && !this.validatePhone() ||
            this.code !== '' && !this.validateCode() ||
            this.password !== '' && !this.validatePassword()){
          this.$toast.fail(this.tip)
          return
        }
        setting({
          code: this.code,
          password: this.password,
          repassword: this.repassword,
          isService: this.isService,
          isForgetPassword: this.isForgetPassword
        }).then(response => {
          this.loading = false
          this.$toast.success(response.message)
          this.showCountDown = false
          this.code = ''
          this.password = ''
          this.repassword = ''
        }).catch(error => {
          this.loading = false
          console.log(error)
        })
      },
      //清除文本框
      clear(val) {
        this[val] = ''
      },
      //验证手机
      validatePhone() {
        if (!(/^[1][0-9]{10}$/.test(this.mobile))) {
          this.tip = '手机号格式不正确'
          return false;
        }
        return true;
      },
      //验证密码
      validatePassword() {
        if (this.password.length < 6 || this.password.length >18) {
          this.tip = '密码长度6到18位'
          return false;
        }
        if (this.password != this.repassword) {
          this.tip = '两次密码输入不一致'
          return false
        }
        return true
      },
      //验证验证码
      validateCode() {
        if (!(/^[0-9]\d*$/.test(this.code))) {
          this.tip = '验证码请填写数字类型'
          return false;
        }else if(!(this.code.length == 6)){
          this.tip = '验证码长度错误'
          return false;
        }
        return true
      },
    }
  }
</script>

<style lang="less" scoped>
  .home-wrap{
    font-family: Alibaba-PuHuiTi-R;
    .mobile{
      font-family: Alibaba-PuHuiTi-M;
      padding-left: 24px;
    }
    .input-wrap,.code-wrap{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 5px 10px;
      background: #FFFFFF;
      border: 1px solid #EEEEEE;
      border-radius: 2px;
      margin-top: 20px;
      img{
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
    }
    .input-wrap{
      input{
        width: 90%;
        font-size: 14px;
        color: #222222;
        padding: 5px;
        border: none;
      }
    }
    .code-wrap{
      border: none;
      padding: 0;
      input{
        width: 80%;
        padding: 5px;
      }
      .text-wrap{
        width: 60%;
        height: 100%;
        border: 1px solid #EEEEEE;
        border-radius: 2px;
        padding: 5px 10px;
      }
    }
    .code-btn,.clock-btn{
      width: 40%;
      height: 42px;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
      margin-left: 10px;
      background: #FF9734;
      color: #FFFFFF;
    }
    .service-wrap{
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      .van-radio-group{
        display: flex;
        flex-direction: row;
        .van-radio{
          padding-right: 20px;
        }
      }
      .img-icon{
        width: 22px;
      }
    }
    .service-tip{
      margin-top: 20px;
      font-size: 12px;
      color: #999999;
    }
    .submit-btn{
      display: block;
      background: #FF9734;
      color: #FFFFFF;
      height: 46px;
      line-height: 46px;
      text-align: center;
      font-size: 18px;
    }
  }
  ::-webkit-input-placeholder {
    font-family: Alibaba-PuHuiTi-R;
    font-size: 14px;
    color: #CCCCCC;
    letter-spacing: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/setting/Index.vue